import $ from 'jquery';
window.$ = $;
window.jQuery = $;
window.jquery = $;
import 'bootstrap';

require('./views/tilbod-container');
require('./views/mypages-container');
require('./views/companypages-container');
require('./views/agent-menu');
require('./views/vidbotarlifeyrir-reiknivel-container');
require('./views/ax-signing-container');


import "../../sass/main.scss"

var MobileDetect = require('mobile-detect')
window.md = new MobileDetect(window.navigator.userAgent);